// extracted by mini-css-extract-plugin
export default {"page":"NewsDetailPage_page__dhO8i","head":"NewsDetailPage_head__o1oLt","article":"NewsDetailPage_article__bqSRs","body":"NewsDetailPage_body__Bgf--"};